export const constructLocalisedProductLink = (product) => {
  const marketRoot = window.theme.locale.rootUrl === '/' ? '' : window.theme.locale.rootUrl;
  return `${window.location.origin}${marketRoot}/products/${product.handle}`;
};

window.constructLocalisedProductLink = constructLocalisedProductLink;
